import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsArrowLeftNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15 21.414l-8-8a2 2 0 010-2.828l8-8L16.414 4l-8 8 8 8z"
        fill=""
      />
    </svg>
  )
);
SvgActionsArrowLeftNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsArrowLeftNormalSmall;
